import React from "react";
import { Field, useField } from "formik";
import styles from "./Input3.module.scss";
import { ReactComponent as Visibility } from "../../assets/SVGs/eye-filled.svg";
import { ReactComponent as VisibilityOff } from "../../assets/SVGs/eye-filled-hide.svg";

function Input3(props) {
  const disabled = props.disabled || false;
  const [field, meta] = useField(props);
  const [iconPass, setIconPass] = React.useState(true);
  const [passType, setPassType] = React.useState("password");

  const changeInputType = () => {
      setPassType(prevType => prevType === "password" ? "text" : "password");
      setIconPass(prevType => prevType === true ? false : true);
    };

  return (
    <div className={`${styles.input4} ${styles.radio} ${props.className}`}>
      { (props.label || props.title) && (
        <div className={styles.labelContainer}>
          <label htmlFor={props.name} className={styles.title}>{props.label || props.title}</label>
          <div className={styles.optional} style={{display: (props.optional ? "flex" : "none")}}>(Optional)</div>
        </div>
      )}
      <div className={`${styles.captionContainer} ${props.full && styles.full}`}>
        { props.input === "checklist" ? (
          <div className={styles.checkList}>
            {props.options.map((option, i) => {
              return (
                <div key={i} className={`${styles.clOption}`}>
                  <input
                    className={styles.checkListInput}
                    type="checkbox"
                    name={props.name}
                    checked={props.selectedOption === option}
                    onChange={() =>
                      props.onChange(props.name, option, "checkbox")
                    }
                    disabled={disabled}
                  />
                  <div className={styles.label}>{option}</div>
                </div>
              );
            })}
          </div>
        ) : props.input=== "checkbox" ? (
          <label className={styles.checkbox}>
            <input {...field} {...props} type="checkbox" />
            {props.children}
          </label>
        ) : props.input === "radio" ? (
          <div className={styles.checkList}>
            {props.options && props.options.map((option, i) => {
              return (
                <label key={i} className={`${styles.clOption}`}>
                  <Field
                    className={styles.checkListInput}
                    type="radio"
                    name={props.name}
                    value={option}
                    disabled={disabled}
                  />
                  <span className={styles.label}>{option}</span>
                </label>
              );
            })}
          </div>
        ) : props.input === "boxes" ? (
          <div className={styles.boxList}>
            {props.options.map((option, i) => {
              return (
                  <label key={i} className={`${styles.clOption}`}>
                    <Field
                      className={styles.checkListInput}
                      type="radio"
                      name={props.name}
                      value={option}
                      disabled={disabled}
                    />
                    <span className={`${props.md ? styles.md : styles.sm} ${styles.label}`}>{option}</span>
                  </label>
              );
            })}
          </div>
        ) : props.input === "password" ? (
          <Field name={props.name} {...props}>
              {({ field }) => (
                <div className={`${styles.password}`}>
                  <input
                    type={passType}
                    className={`${styles.input}`}
                    {...field}
                    {...props}
                  />
                  <i onClick={changeInputType} className={styles.iconDiv}>
                    {iconPass ? (
                      <Visibility className={styles.icon} />
                    ) : (
                      <VisibilityOff className={styles.icon} />
                    )}
                  </i>
                </div>
              )}
            </Field>
        ) : props.input === "textarea" ? (
          <Field
            name={props.name}
            as="textarea"
            className={`${styles.textArea}`}
            {...props}
          />
        ) : props.input === "dropdown" ? (
          <Field
            name={props.name}
            as="select"
            className={styles.dropdownContainer}
            {...props}
          >
            <option value="" disabled>{props.placeholder || "Select an Option"}</option>
            {props.options && props.options.map((option, i) => {
              return (
                <option
                  key={i}
                  type="radio"
                  name={props.name}
                  value={option}
                >
                  {option}
                </option>
              );
            })}
          </Field>
        ) : (
          <input
            className={`${styles.input}`}
            type={props.type || "text"}
            {...field}
            {...props}
          />
        )}
        <p className={styles.caption} style={{display: (props.caption ? "flex" : "none")}}>{props.caption}</p>
        {meta.touched && meta.error ? (
          <div className={styles.error}>{meta.error}</div>
        ) : null}
      </div>
    </div>
  );
}

const Checkbox = ({ children, ...props }) => {
  const [field, meta] = useField({ ...props, type: "checkbox" });
  return (
    <div className={styles.captionContainer}>
      <label className={styles.checkbox}>
        <input {...field} {...props} type="checkbox" />
        {children}
      </label>
      {meta.touched && meta.error ? (
        <div className={styles.error}>{meta.error}</div>
      ) : null}
    </div>
  );
};

export { Checkbox, Input3 };
